interface ToggleTypeFunc {
	(): void;
}

type ToggleTypeIconProps = {
	toggleType: ToggleTypeFunc;
	classes?: string;
};

const Icon = () => (
	<svg width="16px" height="16px" viewBox="0 0 18 18" data-testid="ToggleTypeIconLogo" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M10.4224 13.008C11.0025 13.008 11.5589 12.7776 11.9692 12.3673C12.3794 11.9571 12.6099 11.4007 12.6099 10.8205C12.6099 10.7565 12.6069 10.693 12.6015 10.6303L10.2321 12.9996C10.2948 13.0051 10.3581 13.008 10.4224 13.008ZM17.663 4.05413L16.8286 3.22053C16.7993 3.19125 16.7596 3.1748 16.7182 3.1748C16.6767 3.1748 16.637 3.19125 16.6077 3.22053L14.4725 5.35628C13.2947 4.75432 11.9707 4.45335 10.5005 4.45335C6.74657 4.45335 3.94579 6.40842 2.09814 10.3186C2.02387 10.4758 1.98535 10.6476 1.98535 10.8215C1.98535 10.9954 2.02387 11.1672 2.09814 11.3244C2.83642 12.8795 3.72541 14.1259 4.76513 15.0637L2.69892 17.1291C2.66964 17.1584 2.65319 17.1982 2.65319 17.2396C2.65319 17.281 2.66964 17.3207 2.69892 17.35L3.53271 18.1838C3.56201 18.2131 3.60173 18.2295 3.64315 18.2295C3.68458 18.2295 3.7243 18.2131 3.7536 18.1838L17.663 4.27522C17.6775 4.26071 17.689 4.24348 17.6969 4.22451C17.7048 4.20554 17.7088 4.18521 17.7088 4.16467C17.7088 4.14414 17.7048 4.12381 17.6969 4.10484C17.689 4.08587 17.6775 4.06864 17.663 4.05413ZM6.98485 10.8205C6.9848 10.2268 7.13853 9.64316 7.43108 9.1265C7.72363 8.60984 8.14501 8.17775 8.65418 7.87235C9.16334 7.56694 9.74294 7.39862 10.3365 7.38379C10.93 7.36896 11.5173 7.50812 12.0411 7.78772L11.0915 8.73733C10.7085 8.6147 10.2992 8.59994 9.90837 8.69465C9.51756 8.78935 9.16039 8.98988 8.87605 9.27423C8.5917 9.55857 8.39118 9.91574 8.29647 10.3065C8.20176 10.6974 8.21652 11.1067 8.33915 11.4897L7.38954 12.4393C7.12306 11.9414 6.98402 11.3853 6.98485 10.8205V10.8205Z"
			fill="#BA9FC5"
		/>
		<path
			d="M18.9025 10.3164C18.215 8.86849 17.3967 7.68783 16.4477 6.77441L13.6324 9.58984C13.8697 10.2102 13.9223 10.886 13.7839 11.5356C13.6454 12.1852 13.3218 12.7807 12.8522 13.2504C12.3825 13.72 11.7869 14.0436 11.1373 14.1821C10.4877 14.3206 9.81194 14.268 9.1916 14.0307L6.80371 16.4186C7.91152 16.9312 9.14369 17.1875 10.5002 17.1875C14.2541 17.1875 17.0549 15.2324 18.9025 11.3223C18.9768 11.165 19.0153 10.9933 19.0153 10.8193C19.0153 10.6454 18.9768 10.4737 18.9025 10.3164V10.3164Z"
			fill="#BA9FC5"
		/>
	</svg>
);

const ToggleTypeIcon = ({ toggleType, classes }: ToggleTypeIconProps) => {
	return (
		<span className={classes} onClick={toggleType}>
			<Icon />
		</span>
	);
};

export default ToggleTypeIcon;
